import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";

function FeePlanClassWise() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm();

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [centersData, setCentersData] = useState([]);
  const [centerClassesConcessionType, setCenterClassesConcessionType] =
    useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setCentersData(response);

        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCenters();
  }, []);

  useEffect(() => {
    const fetchCenterClassesConcessionPlanByCenterId = async (id) => {
      setLoading(true);
      try {
        const response = await post(
          `ConcessionType/GetCenterClassesConcessionTypeByCenterIdAsync?centerId=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { centerClassesConcessionType } = response;

        setCenterClassesConcessionType(centerClassesConcessionType);
        // reset();
      } catch (error) {
        console.error("Error fetching CenterClassesFeePlan:", error);
      } finally {
        setLoading(false);
      }
    };

    // if (centerId > 0) {
    fetchCenterClassesConcessionPlanByCenterId(centerId);
    // }
  }, [centerId]);

  const handleCenterDropdownChange = (event) => {
    const selectedCenterId = Number(event.target.value);
    setCenterId(selectedCenterId);
    setCenterClassesConcessionType([]);
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    toast.error("An unexpected error occurred");
    return;

    const formData = centerClassesConcessionType.flatMap(
      (centerItem, centerIndex) =>
        centerItem.centerConcessionTypeDetail.map((detail, detailIndex) => ({
          id: detail.id,
          amount:
            data.concessionTypeDetail[
              centerIndex * centerItem.centerConcessionTypeDetail.length +
                detailIndex
            ]?.concessionPercentage || 0,
        }))
    );

    try {
      const response = await post(
        "ConcessionType/UpdateCenterClassesFeeTypePercentageAsync",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Concession Plan Class Wise</h2>
      </div>

      <div className="row g-3">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <form
                className="new-form-style"
                onSubmit={handleSubmit(saveData)}
              >
                <div className="row g-3 mb-3">
                  <div className="col-md-5">
                    <label className="form-label form-label-new">Center</label>
                    <Controller
                      name="centerId"
                      control={control}
                      rules={{ required: "This field is required." }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={centersData.map((center) => ({
                            value: center.id,
                            label: center.name,
                          }))}
                          isDisabled={savedCenterId !== "0"}
                          onChange={(selectedOption, actionMeta) => {
                            if (actionMeta.action === "clear") {
                              setValue(`centerId`, null);
                            } else {
                              setValue(
                                `centerId`,
                                selectedOption || { value: 0, label: "" }
                              );
                              setCenterId(selectedOption.value);
                            }
                            trigger(`centerId`);
                          }}
                          className="react-select-style"
                          classNamePrefix="react-select-style-pref"
                          // isClearable={!savedCenterId}
                        />
                      )}
                    />
                    {errors.centerId && (
                      <small className="text-danger">
                        {errors.centerId.message}
                      </small>
                    )}
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-md-12">
                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      <table className="table table-bordered custom-table m-0">
                        <thead>
                          <tr>
                            <th>Class</th>
                            <th>Fee Type</th>
                            <th>Fee Percentage (%)</th>
                            <th>One Time</th>
                            <th>Recurring</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!centerClassesConcessionType.length ? (
                            <tr className="text-center w-100">
                              <td colSpan="5">
                                There are no records to display
                              </td>
                            </tr>
                          ) : (
                            centerClassesConcessionType.map(
                              (centerItem, centerIndex) =>
                                centerItem.centerConcessionTypeDetail.map(
                                  (item, index) => (
                                    <tr key={item.id}>
                                      {index === 0 && (
                                        <th
                                          rowSpan={
                                            centerItem
                                              .centerConcessionTypeDetail.length
                                          }
                                        >
                                          {centerItem.className}
                                        </th>
                                      )}
                                      <td>{item.feeTypeName}</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          {...register(
                                            `concessionTypeDetail[${
                                              centerIndex *
                                                centerItem
                                                  .centerConcessionTypeDetail
                                                  .length +
                                              index
                                            }].concessionPercentage`,
                                            {
                                              value: item.concessionPercentage,
                                              maxLength: {
                                                value: 75,
                                                message:
                                                  "Maximum of 75 characters allowed.",
                                              },
                                            }
                                          )}
                                          defaultValue={
                                            item.concessionPercentage
                                          }
                                          onInput={(e) => {
                                            if (e.target.value < 0) {
                                              e.target.value = 0;
                                            }
                                          }}
                                          onChange={handleChangeOfInputWithLengthCheck(
                                            `concessionTypeDetail[${
                                              centerIndex *
                                                centerItem
                                                  .centerConcessionTypeDetail
                                                  .length +
                                              index
                                            }].concessionPercentage`
                                          )}
                                          disabled
                                        />
                                        {errors.concessionTypeDetail?.[
                                          centerIndex *
                                            centerItem
                                              .centerConcessionTypeDetail
                                              .length +
                                            index
                                        ]?.concessionPercentage && (
                                          <div className="text-danger">
                                            {
                                              errors.concessionTypeDetail[
                                                centerIndex *
                                                  centerItem
                                                    .centerConcessionTypeDetail
                                                    .length +
                                                  index
                                              ]?.concessionPercentage?.message
                                            }
                                          </div>
                                        )}
                                      </td>
                                      <td>
                                        <div className="d-flex justify-content-center">
                                          <span
                                            className={`text-primary fa ${
                                              item.feeFrequency === "One Time"
                                                ? "fa-check"
                                                : ""
                                            }`}
                                          ></span>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-flex justify-content-center">
                                          <span
                                            className={`text-primary fa ${
                                              item.feeFrequency === "Recurring"
                                                ? "fa-check"
                                                : ""
                                            }`}
                                          ></span>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )
                            )
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-primary btn-sm"
                      type="submit"
                      // disabled={isSubmitting}
                      disabled
                    >
                      {isSubmitting ? "Save" : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeePlanClassWise;
